import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  MenuItem,
  Typography,
} from '@mui/material';
import { WorkItem } from '../../models/workItem';

interface AddWorkItemModalProps {
  open: boolean;
  onClose: () => void;
  onSave: (newWorkItem: WorkItem) => void;
}

const AddWorkItemModal: React.FC<AddWorkItemModalProps> = ({
  open,
  onClose,
  onSave,
}) => {
  const [newWorkItem, setNewWorkItem] = useState<Partial<WorkItem>>({
    description: '',
    status: 'NOT STARTED',
    type: 'REPAIR',
    cost: 0,
  });

  const handleSave = () => {
    if (newWorkItem.description && newWorkItem.type && newWorkItem.status) {
      const newItem: WorkItem = {
        id: `${Date.now()}`,
        description: newWorkItem.description,
        status: newWorkItem.status as WorkItem['status'],
        type: newWorkItem.type as WorkItem['type'],
        cost: newWorkItem.cost || 0,
      };
      onSave(newItem);
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
          Add New Work Item
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 3 }}>
          <TextField
            label="Description"
            fullWidth
            value={newWorkItem.description}
            onChange={(e) =>
              setNewWorkItem((prev) => ({ ...prev, description: e.target.value }))
            }
          />
          <TextField
            label="Type"
            select
            fullWidth
            value={newWorkItem.type}
            onChange={(e) =>
              setNewWorkItem((prev) => ({ ...prev, type: e.target.value as WorkItem['type'] }))
            }
          >
            <MenuItem value="REPAIR">Repair</MenuItem>
            <MenuItem value="RENOVATION">Renovation</MenuItem>
          </TextField>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSave} color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddWorkItemModal;
